import { httpPost } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { GamificationEvent } from './types';

/**
 * Emits events gamification events for gamification service
 *
 * @method emitEvent
 * @memberof Gamification
 * @param  {GamificationEvent} gamificationEvent - Event to be transmitted
 * @returns {Promise<any>}
 */

// TODO: Set up typing for emitEvent
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const emitEvent = async (gamificationEvent: GamificationEvent): Promise<any> => {
  const url = `${Constants.BACKEND_URL}/achievements/event`;

  return httpPost(url, gamificationEvent)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw Error(error);
    });
};
